import{Sidebar as SemanticSidebar}from"semantic-ui-react";export const Sidebar=SemanticSidebar;export default Sidebar;
//# sourceMappingURL=Sidebar.js.map
